<template>
  <div>
    <client-only>
      <footer
        class="flex flex-wrap flex-col items-center text-center mt-auto sm:items-start sm:text-left sm:flex-row sm:justify-evenly bg-dark-blue text-gray-500 p-10"
      >
        <div>
          <div
            v-if="shouldDisplaySocialLinks"
            class="flex justify-center items-center sm:justify-start flex-wrap -mx-4 p-4"
          >
            <a
              v-for="(link, i) of socialLinks"
              :key="i"
              :href="link.url"
              target="_blank"
              class="p-0 m-2 text-enterprise-primary hover:text-white"
              rel="noopener"
            >
              <component :is="`${link.name}Icon`" class="w-5 h-5" />
            </a>
          </div>

          <div class="flex flex-col sm:flex-row items-center flex-wrap p-2">
            <BrandLogo :dark="false" class="my-6 sm:my-0 sm:mr-4" />

            <small
              >&copy; {{ companyName }} {{ year }}. All Rights Reserved.</small
            >
          </div>
        </div>

        <template v-if="columns.length > 0">
          <div
            v-for="(column, i) of columns"
            :key="i"
            class="p-4 flex flex-col stack"
          >
            <p class="text-white font-bold">
              {{ column.heading }}
            </p>

            <a
              v-for="(link, j) of column.links"
              :key="j"
              :href="link.url"
              class="p-0"
            >
              {{ link.text }}
            </a>
          </div>
        </template>
      </footer>
    </client-only>
  </div>
</template>

<script>
import InstagramIcon from '@/assets/svg/social/instagram.svg?inline'
import FacebookIcon from '@/assets/svg/social/facebook.svg?inline'
import LinkedinIcon from '@/assets/svg/social/linkedin.svg?inline'
import TwitterIcon from '@/assets/svg/social/twitter.svg?inline'
import BrandLogo from '@/components/BrandLogo'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    InstagramIcon,
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    BrandLogo,
  },

  computed: {
    shouldDisplaySocialLinks() {
      return this.theme.footer.include_social_links
    },

    theme() {
      return this.enterprise.theme
    },

    socialLinks() {
      return this.theme.social_links
    },

    columns() {
      return this.theme.footer.columns
    },

    year() {
      return new Date().getFullYear()
    },

    ...mapState(['enterprise']),
    ...mapGetters(['companyName']),
  },
}
</script>

<style lang="scss"></style>
